module.exports = __webpack_public_path__ + "static/media/image_9.352d1bf5.png";